var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebookShare = function SvgFacebookShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m92 20c4.418278 0 8 3.581722 8 8 0 3.9582078-2.8746368 7.2450083-6.6501008 7.8865916l-.0006482-5.4923086h1.803226l.3432153-2.2790371h-2.1464413v-1.4789057c0-.6235813.2998086-1.2313931 1.2611478-1.2313931h.9758081v-1.9403353c-.5729353-.0944628-1.1518949-.1460232-1.7322276-.154267-1.7678951 0-2.9233865 1.0915244-2.9233865 3.0678553v1.7370458h-1.9650756v2.2790371h1.9650756v5.5097296c.3958795.0632276.7953419.0952188 1.194847.0959737l-.1254398.0000137c-4.418278 0-8-3.581722-8-8s3.581722-8 8-8z",
    fill: "#1877f2",
    transform: "translate(-84 -20)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookShare, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Cipher/static/media/FacebookShare.a1134a10.svg";
export { ForwardRef as ReactComponent };